export type Spacing = keyof typeof SPACING;
export const SPACING = {
    0: 0,
    25: 2,
    50: 4,
    100: 8,
    200: 16,
    300: 24,
    400: 32,
    500: 40,
    700: 56,
    900: 72,
    1200: 96,
} as const;
